import { styled } from '@linaria/react'
import React, { ComponentProps, FC, ReactNode } from 'react'
import { Typography } from './Typography'
import { colors } from '../styles/colors'

type TextAlignProp = 'center' | 'end' | 'start'

export const TitleAndSubtitle: FC<{
  title?: ReactNode
  titleFontSize?: ComponentProps<typeof Typography>['fontSize']
  subtitle?: ReactNode
  gap?: string
  isShowSeparator?: boolean
  textAlign?: TextAlignProp
}> = ({
  title,
  subtitle,
  titleFontSize = 20,
  gap = '4px',
  isShowSeparator = true,
  textAlign = 'start',
}) => {
  return (
    <Block gap={gap} $textAlign={textAlign}>
      {title && (
        <Typography fontSize={titleFontSize} fontWeight={600}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography fontSize={16} fontWeight={400}>
          {subtitle}
        </Typography>
      )}

      {isShowSeparator && <Separator />}
    </Block>
  )
}

const Block = styled.div<{ gap: string; $textAlign: TextAlignProp }>`
  display: grid;
  gap: ${props => props.gap};
  grid-gap: ${props => props.gap};
  text-align: ${props => props.$textAlign};
`

const Separator = styled.div`
  margin-top: 12px;
  border-bottom: 1px solid ${colors.secondary};
`
